<div class="bulk-upload-drop" appDragAndDropFile (fileDropped)="handleDrop($event)">
  <div class="bulk-upload-drop__content">
    <app-pencil-icon class="bulk-upload-drop__icon" [name]="'import'" [type]="IconTypes.svgIcon">
    </app-pencil-icon>
    <p class="bulk-upload-drop__title">{{ 'Drag and drop files here' | translate }}</p>
    <ng-container *ngIf="(showSelectedState$ | async) === false">
      <p class="bulk-upload-drop__formats">
        {{ 'Supported formats: Images, Documents, Videos, and .space files' | translate }}
      </p>

      <div class="bulk-upload-drop__separator">
        <mat-divider class="bulk-upload-drop__separator-line"></mat-divider>
        <p class="bulk-upload-drop__separator-text">{{ 'or' | translate }}</p>
        <mat-divider class="bulk-upload-drop__separator-line"></mat-divider>
      </div>
    </ng-container>

    <input
      #fileUpload
      type="file"
      multiple
      [accept]="config.supportedTypes"
      class="bulk-upload-drop__input"
      (change)="handleInputChange($event)"
      data-name="bulk-upload-select-files"
    />

    <ng-container *ngIf="(showSelectedState$ | async) === false">
      <app-pencil-button
        class="pencil-button primary medium bulk-upload-drop__button"
        [label]="'Select file' | translate"
        [icon]="'attach_file'"
        [iconConfig]="{ type: IconTypes.materialIcon }"
        (clickEvent)="fileUpload.click()"
      >
      </app-pencil-button>

      <div
        class="bulk-upload-drop__error"
        *ngIf="errorMessage$ | async as errorMessage; else uploadLimit"
      >
        <app-pencil-icon
          class="bulk-upload-drop__error-icon"
          [name]="'error_outline'"
          [type]="IconTypes.materialIcon"
          [outlined]="true"
        ></app-pencil-icon>
        <p class="bulk-upload-drop__error-text">{{ errorMessage }}</p>
      </div>
      <ng-template #uploadLimit>
        <p class="bulk-upload-drop__limit">
          <app-pencil-icon
            class="bulk-upload-drop__limit-icon"
            [name]="'info_outline'"
            [type]="IconTypes.materialIcon"
          >
          </app-pencil-icon>
          {{
            'You can only upload up to {{count}}
          files at once' | translate: { count: config.maxFiles } }}
        </p>
      </ng-template>
    </ng-container>

    <ng-container *ngIf="showSelectedState$ | async">
      <p class="bulk-upload-drop__selected-name">{{ selectedFileName$ | async }}</p>
    </ng-container>
  </div>
</div>
